import request from '@/utils/request';

// 轮播图列表
export const getBackendBannerList = (data: any): any =>
  request({
    url: '/pc/carousel/list',
    data: data
  })

// 创建轮播
export const createBanner = (data: any): any =>
  request({
    url: '/pc/carousel/save',
    data: data
  })

// 删除轮播
export const deleteBanner = (data: any): any =>
  request({
    url: '/pc/carousel/delete',
    data: data
  })

// 设置轮播
export const setBanner = (data: any): any =>
  request({
    url: '/pc/carousel/changeIsOpen',
    data
  })

// 轮播详情
export const bannerDetail = (data: any): any =>
  request({
    url: '/pc/carousel/detail',
    data
  })


// 素材列表
export const getBackendMaterialList = (data: any): any =>
  request({
    url: '/pc/material/list',
    data: data
  })

// 创建素材
export const createMaterial = (data: any): any =>
  request({
    url: '/pc/material/save',
    data: data
  })

// 编辑素材
export const updateMaterial = (data: any): any =>
  request({
    url: '/pc/material/save',
    data: data
  })

// 删除素材
export const deleteMaterial = (data: any): any =>
  request({
    url: '/pc/material/delete',
    data: data
  })

// 素材信息
export const materialDetail = (data: any): any =>
  request({
    url: '/pc/material/detail',
    data
  })


// 资讯列表
export const getBackendActivityList = (data: any): any =>
  request({
    url: '/pc/information/list',
    data: data
  })

// 更新资讯
export const setActivityInfo = (data: any): any =>
  request({
    url: '/pc/information/changeIsOpen',
    data: data
  })

// 创建资讯
export const createActivityInfo = (data: any): any =>
  request({
    url: '/pc/information/save',
    data: data
  })

// 删除资讯
export const deleteActivityInfo = (data: any): any =>
  request({
    url: '/pc/information/delete',
    data: data
  })

// 获取资讯详情
export const getActivityDetail = (data: any): any =>
  request({
    url: '/pc/information/detail',
    data: data
  })

// 公告列表
export const getBackendAnnouncementList = (data: any): any =>
  request({
    url: '/pc/announcement/list',
    data: data
  })

// 创建公告
export const createAnnouncement = (data: any): any =>
  request({
    url: '/pc/announcement/save',
    data: data
  })

// 设置公告
export const setAnnouncement = (data: any): any =>
  request({
    url: '/pc/announcement/changeIsOpen',
    data: data
  })

// 公告详情
export const getAnnouncementDetail = (data: any): any =>
  request({
    url: '/pc/announcement/detail',
    data: data
  })

// 删除公告
export const delAnnouncement = (data: any): any =>
  request({
    url: '/pc/announcement/delete',
    data: data
  })


// 商品素材
export const productMaterialList = (data: any): any =>
  request({
    url: '/pc/productMaterial/list',
    data: data
  })
  
// 商品素材-详情
export const productMaterialDetail = (data: any): any =>
  request({
    url: '/pc/productMaterial/detail',
    data: data
  })

// 商品素材-保存
export const productMaterialSave = (data: any): any =>
  request({
    url: '/pc/productMaterial/save',
    data: data
  })
  
// 商品素材-删除
export const productMaterialDelete = (data: any): any =>
  request({
    url: '/pc/productMaterial/delete',
    data: data
  })

// 专场系列 保存
export const productproductSpecialSave = (data: any): any =>
  request({
    url: '/pc/product/productSpecialSave',
    data: data
  })

// 专场系列 列表
export const productproductSpecialList = (data: any): any =>
  request({
    url: '/pc/product/productSpecialList',
    data: data
  })

// 专场系列 删除
export const productproductSpecialDelete = (data: any): any =>
  request({
    url: '/pc/product/productSpecialDelete',
    data: data
  })

// 用户分析
export const dataStatisdataStatisMemberAnalysis = (data: any): any =>
  request({
    url: '/pc/dataStatis/dataStatisMemberAnalysis',
    data: data
  })

// 商品下单分析(饼状图) 
export const dataStatisProductSellAnalysispriceSellDistribution = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/priceSellDistribution',
    data: data
  })

// 商品销量分析
export const dataStatisProductSellAnalysisproductSellCountAnalysis = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/productSellCountAnalysis',
    data: data
  })

// 商品下单概况
export const dataStatisProductSellAnalysisproductOrderOverview = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/productOrderOverview',
    data: data
  })

// 团队销量分析
export const dataStatisProductSellAnalysisteamSellCountAnalysis = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/teamSellCountAnalysis',
    data: data
  })

// 交易概况 订单金额分布
export const transactionOvervieworderMoneyDistribution = (data: any): any =>
request({
  url: '/pc/dataStatis/transactionOverview/orderMoneyDistribution',
  data: data
})
// 交易概况-成交客户构成
export const transactionOverviewtradeCustomer = (data: any): any =>
request({
  url: '/pc/dataStatis/transactionOverview/tradeCustomer',
  data: data
})
// 交易概况-成交场景分析
export const transactionOverviewtradeScene = (data: any): any =>
request({
  url: '/pc/dataStatis/transactionOverview/tradeScene',
  data: data
})
// 交易概况
export const transactionOverviewtradeOverview = (data: any): any =>
request({
  url: '/pc/dataStatis/transactionOverview/tradeOverview',
  data: data
})
// 交易概况-列表（折线图）
export const transactionOverviewtradeOverviewList = (data: any): any =>
request({
  url: '/pc/dataStatis/transactionOverview/tradeOverviewList',
  data: data
})

// 团队分析--销售涨幅分析
export const dataStatisdataStatisMemberTeamAnalysisSevenDaySell = (data: any): any =>
request({
  url: '/pc//pc/dataStatis/dataStatisMemberTeamAnalysisSevenDaySell',
  data: data
})
// 团队分析--团队代理、订单数据
export const dataStatisdataStatisMemberTeamAnalysisInfo = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisMemberTeamAnalysisInfo',
  data: data
})
// 团队分析-商品销量分析
export const dataStatisdataStatisMemberTeamProductSellAnalysis = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisMemberTeamProductSellAnalysis',
  data: data
})
// 团队分析-单品分析
export const dataStatisdataStatisMemberTeamSingleProductAnalysis = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisMemberTeamSingleProductAnalysis',
  data: data
})
// 团队分析--概览
export const dataStatisMemberTeamoverview = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisMemberTeam/overview',
  data: data
})
// 团队分析--概览-列表
export const dataStatisMemberTeamoverviewList = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisMemberTeam/overviewList',
  data: data
})

// 商品销售分析 商品品类数据分析
export const dataStatisProductSellAnalysiscategorySellCountAnalysis = (data: any): any =>
request({
  url: '/pc/dataStatisProductSellAnalysis/categorySellCountAnalysis',
  data: data
})


// 团队分析-单个团队近7日情况
export const dataStatisdataStatisSingleMembeTeamSevenData = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisSingleMembeTeamSevenData',
  data: data
})
// 团队分析-单个团队产品销售分析
export const dataStatisdataStatisSingleMembeTeamSingleProductAnalysis = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisSingleMembeTeamSingleProductAnalysis',
  data: data
})
// 团队分析-单个团队品类销售分析
export const dataStatisdataStatisSingleMembeTeamProductCategoryAnalysis = (data: any): any =>
request({
  url: '/pc/dataStatis/dataStatisSingleMembeTeamProductCategoryAnalysis',
  data: data
})



// 获取发圈素材列表
export const materialHairRingMaterialmaterialHairRingMaterialPageList = (data: any): any =>
request({
  url: '/pc/materialHairRingMaterial/materialHairRingMaterialPageList',
  data: data
})
// 删除发圈素材
export const materialHairRingMaterialmaterialHairRingMaterialDelete = (data: any): any =>
request({
  url: '/pc/materialHairRingMaterial/materialHairRingMaterialDelete',
  data: data
})
// 获取所有未开团+开团中的商品下拉选项
export const materialrelationProductItem = (data: any): any =>
request({
  url: '/pc/material/relationProductItem',
  data: data
})
// 发圈素材保存
export const materialHairRingMaterialmaterialHairRingMaterialSave = (data: any): any =>
request({
  url: '/pc/materialHairRingMaterial/materialHairRingMaterialSave',
  data: data
})
// 获取发圈素材信息
export const materialHairRingMaterialmaterialHairRingMaterialInfo = (data: any): any =>
request({
  url: '/pc/materialHairRingMaterial/materialHairRingMaterialInfo',
  data: data
})
// 团品笔记列表
export const materialGroupNotesmaterialGroupNotesPageList = (data: any): any =>
request({
  url: '/pc/materialGroupNotes/materialGroupNotesPageList',
  data: data
})
// 删除团品笔记
export const materialGroupNotesmaterialGroupNotesDelete = (data: any): any =>
request({
  url: '/pc/materialGroupNotes/materialGroupNotesDelete',
  data: data
})
// 团品笔记保存
export const materialGroupNotesmaterialGroupNotesSave = (data: any): any =>
request({
  url: '/pc/materialGroupNotes/materialGroupNotesSave',
  data: data
})
// 获取团品笔记信息
export const materialGroupNotesmaterialGroupNotesInfo = (data: any): any =>
request({
  url: '/pc/materialGroupNotes/materialGroupNotesInfo',
  data: data
})

// 种草秀标签-列表
export const materialGrassShowtaglist = (data: any): any =>
request({
  url: '/pc/materialGrassShow/tag/list',
  data: data
})
// 种草秀标签-保存
export const materialGrassShowtagsave = (data: any): any =>
request({
  url: '/pc/materialGrassShow/tag/save',
  data: data
})
// 种草秀标签-删除
export const materialGrassShowtagdelete = (data: any): any =>
request({
  url: '/pc/materialGrassShow/tag/delete',
  data: data
})
// 种草秀-列表
export const materialGrassShowlist = (data: any): any =>
request({
  url: '/pc/materialGrassShow/list',
  data: data
})
// 种草秀-拉黑
export const materialGrassShowpullBlack = (data: any): any =>
request({
  url: '/pc/materialGrassShow/pullBlack',
  data: data
})
// 种草秀-恢复
export const materialGrassShowrecover = (data: any): any =>
request({
  url: '/pc/materialGrassShow/recover',
  data: data
})
// 种草秀-详情
export const materialGrassShowdetail = (data: any): any =>
request({
  url: '/pc/materialGrassShow/detail',
  data: data
})
// 种草秀-审核通过
export const materialGrassShowpass = (data: any): any =>
request({
  url: '/pc/materialGrassShow/pass',
  data: data
})
// 种草秀-审核驳回
export const materialGrassShowreject = (data: any): any =>
request({
  url: '/pc/materialGrassShow/reject',
  data: data
})
// 种草秀-评论列表
export const materialGrassShowcommentlist = (data: any): any =>
request({
  url: '/pc/materialGrassShow/comment/list',
  data: data
})
// 种草秀-评论删除
export const materialGrassShowcommentdelete = (data: any): any =>
request({
  url: '/pc/materialGrassShow/comment/delete',
  data: data
})
// 团品笔记显示/隐藏
export const materialGroupNotesmaterialGroupNotesEditShow = (data: any): any =>
request({
  url: '/pc/materialGroupNotes/materialGroupNotesEditShow',
  data: data
})
// 弹屏广告保存
export const playScreenAdvertisingplayScreenAdvertisingSave = (data: any): any =>
request({
  url: '/pc/playScreenAdvertising/playScreenAdvertisingSave',
  data: data
})
// 获取弹屏广告信息
export const playScreenAdvertisingplayScreenAdvertisingInfo = (data: any): any =>
request({
  url: '/pc/playScreenAdvertising/playScreenAdvertisingInfo',
  data: data
})
// 自定义页面列表
export const custompagecustompagelist = (data: any): any =>
request({
  url: '/pc/custompage/custompagelist',
  data: data
})

// 自定义页面删除
export const custompagecustompagedelete = (data: any): any =>
request({
  url: '/pc/custompage/custompagedelete',
  data: data
})
// 自定义页面设置分享图
export const custompagecustompagesetshareimg = (data: any): any =>
request({
  url: '/pc/custompage/custompagesetshareimg',
  data: data
})

// 自定义页面保存
export const custompagecustompagesave = (data: any): any =>
request({
  url: '/pc/custompage/custompagesave',
  data: data
})
// 自定义页面初始化
export const custompagecustompagesaveinit = (data: any): any =>
request({
  url: '/pc/custompage/custompagesaveinit',
  data: data
})
// 商品筛选列表
export const productfilterBoxList = (data: any): any =>
request({
  url: '/pc/product/filterBoxList',
  data: data
})

// 商品筛选列表2
export const productpopoverproductlist = (data: any): any =>
request({
  url: '/pc/product/popoverproductlist',
  data: data
})
// 设置首页
export const mallshopdecoratesethome = (data: any): any =>
request({
  url: '/pc/mall-shop-decorate/set-home',
  data: data
})



// 满减活动列表
export const activityMarkdownlist = (data: any): any =>
request({
  url: '/pc/activityMarkdown/list',
  data: data
})
export const activityMarkdowndata = (data: any): any =>
request({
  url: '/pc/activityMarkdown/data',
  data: data
})
// 删除满减活动
export const activityMarkdowndelete = (data: any): any =>
request({
  url: '/pc/activityMarkdown/delete',
  data: data
})
// 获取满减活动明细
export const activityMarkdowndetail = (data: any): any =>
request({
  url: '/pc/activityMarkdown/detail',
  data: data
})
// 满减活动保存
export const activityMarkdownsave = (data: any): any =>
request({
  url: '/pc/activityMarkdown/save',
  data: data
})


// 我的页面广告配置-列表
export const myPageAdvertisementlist = (data: any): any =>
request({
  url: '/pc/myPageAdvertisement/list',
  data: data
})
// 系统页面列表
export const systemPagelist = (data: any): any =>
request({
  url: '/pc/systemPage/list',
  data: data
})

// 我的页面广告配置-详情
export const myPageAdvertisementdetail = (data: any): any =>
request({
  url: '/pc/myPageAdvertisement/detail',
  data: data
})

// 我的页面广告配置-保存
export const myPageAdvertisementsave = (data: any): any =>
request({
  url: '/pc/myPageAdvertisement/save',
  data: data
})
// 我的页面广告配置-删除
export const myPageAdvertisementdelete = (data: any): any =>
request({
  url: '/pc/myPageAdvertisement/delete',
  data: data
})

// 设置排序值
export const mallshopdecoratesetSort = (data: any): any =>
request({
  url: '/pc/mall-shop-decorate/set-Sort',
  data: data
})


// 推送管理列表
export const memberMessagememberMessageNoticeList = (data: any): any =>
request({
  url: '/pc/memberMessage/memberMessageNoticeList',
  data: data
})
// 立即推送
export const memberMessagememberMessageNoticeSend = (data: any): any =>
request({
  url: '/pc/memberMessage/memberMessageNoticeSend',
  data: data
})

// 获取推送详情
export const memberMessagememberMessageNoticeInfo = (data: any): any =>
request({
  url: '/pc/memberMessage/memberMessageNoticeInfo',
  data: data
})
// 推送保存
export const memberMessagememberMessageNoticeSave = (data: any): any =>
request({
  url: '/pc/memberMessage/memberMessageNoticeSave',
  data: data
})

// 获取文件行数
export const memberMessagememberMessageNoticeMemberCount = (data: any): any =>
request({
  url: '/pc/memberMessage/memberMessageNoticeMemberCount',
  data: data
})


export const couponPriceNameTypeSave = (data: any): any =>
request({
  url: '/pc/mall/couponPriceNameTypeSave',
  data: data
})


// 获取注册成功配置
export const mallregisterSuccessConfig = (data: any): any =>
request({
  url: '/pc/mall/registerSuccessConfig',
  data: data
})
// 保存注册成功配置
export const mallregisterSuccessConfigSave = (data: any): any =>
request({
  url: '/pc/mall/registerSuccessConfigSave',
  data: data
})
// 种草秀-关联商品
export const materialGrassShowrelationProductList = (data: any): any =>
request({
  url: '/pc/materialGrassShow/relationProductList',
  data: data
})
// 种草秀-修改
export const materialGrassShowedit = (data: any): any =>
request({
  url: '/pc/materialGrassShow/edit',
  data: data
})



// 获取弹屏广告列表
export const playScreenAdvertisingplayScreenAdvertisingPageList = (data: any): any =>
request({
  url: '/pc/playScreenAdvertising/playScreenAdvertisingPageList',
  data: data
})
// 弹屏广告删除
export const playScreenAdvertisingplayScreenAdvertisingDelete = (data: any): any =>
request({
  url: '/pc/playScreenAdvertising/playScreenAdvertisingDelete',
  data: data
})

//获取悬浮标信息
export const custompagesuspendedBuoyInfo = (data: any): any =>
request({
  url: '/pc/custompage/suspendedBuoyInfo',
  data: data
})
//悬浮标信息保存
export const custompagesuspendedBuoySave = (data: any): any =>
request({
  url: '/pc/custompage/suspendedBuoySave',
  data: data
})

//获取小程序页面--对应短连接
export const wxappwxappgenerateurllink = (data: any): any =>
request({
  url: '/pc/wxapp/wxappgenerateurllink',
  data: data
})


//种草秀-喜欢人数修改
export const materialGrassShowUpdateLikeCount = (data: any): any =>
request({
  url: '/pc/materialGrassShow/UpdateLikeCount',
  data: data
})

//种草秀白名单列表
export const materialGrassShowWhiteListlist = (data: any): any =>
request({
  url: '/pc/materialGrassShowWhiteList/list',
  data: data
})
//种草秀白名单删除
export const materialGrassShowWhiteListdelete = (data: any): any =>
request({
  url: '/pc/materialGrassShowWhiteList/delete',
  data: data
})
//种草秀白名单用户查找
export const materialGrassShowWhiteListsearch = (data: any): any =>
request({
  url: '/pc/materialGrassShowWhiteList/search',
  data: data
})
//种草秀白名单添加 
export const materialGrassShowWhiteListsave = (data: any): any =>
request({
  url: '/pc/materialGrassShowWhiteList/save',
  data: data
})


export const pagesContentConfig = (data: any): any =>
request({
  url: '/pc/mall/pagesContentConfig',
  data: data
})
export const pagesContentConfigSave = (data: any): any =>
request({
  url: '/pc/mall/pagesContentConfigSave',
  data: data
})

export const personalCenterAddMenuConfigSave = (data: any): any =>
request({
  url: '/pc/personalCenterAddMenuConfig/save',
  data: data
})
export const personalCenterAddMenuConfigList = (data: any): any =>
request({
  url: '/pc/personalCenterAddMenuConfig/list',
  data: data
})

export const dataStatisProductSellAnalysisProductRetailRankList = (data: any): any =>
request({
  url: '/pc/dataStatisProductSellAnalysis/productRetailRankList',
  data: data
})
